import { render, staticRenderFns } from "./Datasources.vue?vue&type=template&id=60ad3e2c&"
import script from "./Datasources.vue?vue&type=script&lang=js&"
export * from "./Datasources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports